'use strict';

/**
 *
 * @name: readMore
 *
 */

function ReadMoreDirective() {

  'ngInject';

  return {
    link: function(scope, element) {

      element.bind('click', function() {

        scope.$apply(function() {

          scope.post.showFullText = true;
          element.closest('[data-hidden-content-wrapper]').find('[data-hidden-content]').removeAttr('data-hidden-content');
          element.remove();
        });
      });
    }
  };
}

export default ReadMoreDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-read-more.directive.js